import React, { createContext, useState } from 'react'; 

const PartnerContext = createContext();

/**
 * @param {React.ReactChild} chidren Children components inside the context
 * @returns {React.Provider} Partner Module context for redirection from other modules
 */
const PartnerProvider = ({ children }) => {
  let [accountObj, setAccountObj] = useState(0);
  const [show, setShow] = useState(false);
  const [fetchPartner,setFetchPartner]=useState(0)
  const [showTag,setShowTag] = useState(false)
  const [showID,setShowID] = useState(0)
    
  return (
    <PartnerContext.Provider value={{ accountObj, setAccountObj, show, setShow,fetchPartner,setFetchPartner,showTag,setShowTag,showID,setShowID}}>
      {children}
    </PartnerContext.Provider>
  );
};

export {PartnerContext, PartnerProvider};
